import { useState } from "react";

export default function CtaBanner() {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText("https://sufeids.cn");
    } catch {
      /* noop */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto w-full max-w-6xl px-4 pb-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-6 py-10 text-center text-background-50 md:px-10 md:py-14">
          <span className="pointer-events-none absolute -left-16 top-0 h-40 w-40 rounded-full bg-primary-600/30 blur-3xl"></span>
          <span className="pointer-events-none absolute -right-10 bottom-0 h-44 w-44 rounded-full bg-accent-600/25 blur-3xl"></span>

          <span className="relative inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-accent-200 ring-1 ring-background-50/15">
            <i className="ri-focus-3-line text-[13px]"></i>
            收藏本页，永不走丢
          </span>
          <h2 className="relative mx-auto mt-5 max-w-2xl font-heading text-2xl font-bold leading-snug md:text-3xl">
            把吃瓜地址最新发布页收进收藏夹
            <br className="hidden sm:block" />
            换网址也能一键找回
          </h2>
          <p className="relative mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-200">
            实时同步新网址、永久入口在线、防屏蔽有提醒。今天就把这里设为你的固定入口，别让任何一场热闹把你落下。
          </p>

          <div className="relative mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={copy}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className={`${copied ? "ri-check-line" : "ri-bookmark-line"} mr-2 text-lg`}></i>
              {copied ? "已加入收藏" : "收藏永久入口"}
            </button>
            <a
              href="#feed"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300/40 px-6 py-3 text-sm font-semibold text-background-100 transition-colors hover:bg-background-50/10"
            >
              回顶部看最新发布
              <i className="ri-arrow-up-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}